import { Statistic } from "antd";
import moment from "moment";
import React from "react";
import "./index.css";

interface ITimeFromNowProps {
  date: string;
  className?: string;
}

const TimeFromNow: React.FC<ITimeFromNowProps> = ({ date, className }) => {
  return (
    <Statistic
      className={`${className} statastics`}
      value={moment(date).fromNow()}
    />
  );
};

export default TimeFromNow;
